import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlFrontendBadgeComponent } from '@app/core/wrappers/bl-frontend-badge.component';
import { BlFrontendButtonComponent } from '@app/core/wrappers/bl-frontend-button.component';
import { BlFrontendCardComponent } from '@app/core/wrappers/bl-frontend-card.component';
import { BlFrontendCheckboxComponent } from '@app/core/wrappers/bl-frontend-checkbox.component';
import { BlFrontendHorizontalStepperComponent } from '@app/core/wrappers/bl-frontend-horizontal-stepper.component';
import { BlFrontendIconComponent } from '@app/core/wrappers/bl-frontend-icon.component';
import { BlFrontendIconButtonComponent } from '@app/core/wrappers/bl-frontend-iconbutton.component';
import { BlFrontendLoadingButtonComponent } from '@app/core/wrappers/bl-frontend-loading-button.component';
import { BlFrontendMeatBallMenuComponent } from '@app/core/wrappers/bl-frontend-meatballmenu.component';
import { BlFrontendSegmentedbuttonComponent } from '@app/core/wrappers/bl-frontend-segmentedbutton.component';
import { TeamBadgesComponent } from '@app/firm-settings/teams/components/team-badges/team-badges.component';
import { ActivityStateMultiSelectorComponent } from '@app/shared/components/activity-states-multi-selector/activity-states-multi-selector.component';
import { TranslocoModule } from '@jsverse/transloco';
import { BlFrontendAlertComponent } from 'src/app/core/wrappers/bl-frontend-alert.component';
import { FileBrowserComponent } from 'src/app/shared/components/new-client/components/tabs/file-browser/file.browser.component';
import { FileBrowserInternalSectionComponent } from 'src/app/shared/components/new-client/components/tabs/file-browser/internal-section/file-browser-internal-section.component';
import { FileBrowserSharedSectionComponent } from 'src/app/shared/components/new-client/components/tabs/file-browser/shared-section/file-browser-shared-section.component';
import { LundifyShareDialogComponent } from 'src/app/shared/components/new-client/components/tabs/file-browser/shared-section/lundify-share-dialog.component';
import { PleaseWaitComponent } from 'src/app/shared/components/please-wait/please-wait.component';
import { BlFrontendEmailInputComponent } from '../core/wrappers/bl-frontend-email-input.component';
import { BlFrontendMiniBadgeComponent } from '../core/wrappers/bl-frontend-mini-badge.component';
import { BlFrontendPhoneInputComponent } from '../core/wrappers/bl-frontend-phone-input.component';
import { BlFrontendRadiobuttonsComponent } from '../core/wrappers/bl-frontend-radiobuttons.component';
import { BlFrontendTextInputComponent } from '../core/wrappers/bl-frontend-text-input.component';
import { BlFrontendTextAreaComponent } from '../core/wrappers/bl-frontend-textarea.component';
import { BlFrontendTooltipComponent } from '../core/wrappers/bl-frontend-tooltip.component';
import { ActivityCommentIconComponent } from './components/activity-comment-icon/activity-comment-icon.component';
import { ActivityDetailsDialog } from './components/activity-details-dialog/activity.details.dialog';
import { ActivityStateSelectorComponent } from './components/activity-states-selector/activity-states-selector.component';
import { AdminPrivilegeDirective } from './components/admin-privilege/admin-privilege.directive';
import { ApplicationFilesComponent } from './components/application-files.component/application-files.component';
import { AssignmentSelectorComponent } from './components/assignment-selector/assignment-selector.component';
import { AuthRoleSelectorsComponent } from './components/auth-role-selector/auth-role-selector.component';
import { BlaIconButtonComponent } from './components/bla-icon-button/bla-icon-button.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { ExportWizardDialogComponent } from './components/cloud-db-export-wizard/export-wizard-dialog.component';
import { CorporateIdentityInputComponent } from './components/corporate-identity-input/corporate-identity-input.component';
import { DeadlineValueComponent } from './components/deadline/deadline-value.component';
import { DueComplianceActivationBoxComponent } from './components/due-compliance-activation-box/due-compliance-activation-box.component';
import { FeatureToggle } from './components/feature-toggle/feature-toggle.component';
import { FeatureToggleDirective } from './components/feature-toggle/feature-toggle.directive';
import { MessagePanelComponent } from './components/message-panel/message-panel.component';
import { MonthsSelector } from './components/month-selector/month-selector.component';
import { MultiSelectDropDownIncludingAllComponent } from './components/multiselect-dropdown/multiselect-dropdown-including-all.component';
import { MultiselectComponent } from './components/multiselect-dropdown/multiselect-dropdown.component';
import { MultiselectWithAllDropdownComponent } from './components/multiselect-dropdown/multiselect-with-all-dropdown.component';
import { ClientActivityListDialogComponent } from './components/new-client/components/client-activity-list-dialog/client-activity-list-dialog.component';
import { ConnectCloudCompanyDialogComponent } from './components/new-client/components/connect-cloud-company-dialog.component';
import { PermissionSelectorComponent } from './components/new-client/components/permission-selector/permission-selector.component';
import { ClientAmlComponent } from './components/new-client/components/tabs/client-aml/client-aml.component';
import { ClientAssignmentsComponent } from './components/new-client/components/tabs/client-assignments/client.assignments.component';
import { ClientBusinessDetailComponent } from './components/new-client/components/tabs/client-business-detail/client.business.detail.component';
import { ClientContactsComponent } from './components/new-client/components/tabs/client-contacts/client.contacts.component';
import { ClientFinancialYearsComponent } from './components/new-client/components/tabs/client-financialyears/client.financialyears.component';
import { EditFinancialYearDialogComponent } from './components/new-client/components/tabs/client-financialyears/edit-financialyear-dialog.component';
import { ClientTodosComponent } from './components/new-client/components/tabs/client-todos/client.todos.component';
import { ApplicationLinksComponent } from './components/new-client/components/tabs/cloud-service/application-links.component';
import { ClientCloudServiceComponent } from './components/new-client/components/tabs/cloud-service/client-cloud-service.component';
import { FirmCollaboratorComponent } from './components/new-client/components/tabs/cloud-service/firm-collaborator.component';
import { ExpenseComponent } from './components/new-client/components/tabs/lundify-subscription/components/expense.component';
import { LundifyBundleComponent } from './components/new-client/components/tabs/lundify-subscription/components/lundify-bundle.component';
import { PayingPartComponent } from './components/new-client/components/tabs/lundify-subscription/components/paying-part.component';
import { UsersComponent } from './components/new-client/components/tabs/lundify-subscription/components/users.component';
import { LundifySubscriptionComponent } from './components/new-client/components/tabs/lundify-subscription/lundify-subscription.component';
import { NewClientDialog } from './components/new-client/new.client.dialog';
import { PartnerProgramAccessDirective } from './components/partner-program-access/partner-program-access.directive';
import { ProgressTimelineModule } from './components/progress-timeline/progress-timeline.module';
import { RuleSelectorComponent } from './components/rule-selector/rule.selector.component';
import { CalendarStatusIconComponent } from './components/status-icon/calendar-status-icon.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { BystTableModule } from './components/table/table.module';
import { TabComponent } from './components/tabs/tab.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TaskCommentIconComponent } from './components/task-comment-icon/task-comment-icon.component';
import { TaskGroupsSelectorComponent } from './components/task-groups-selector/task-groups-selector.component';
import { TaskSelectorComponent } from './components/task-selector/task-selector.component';
import { TeamMultiSelectorComponent } from './components/team-multi-selector/team-multi-selector.component';
import { TodoStatusSelectorComponent } from './components/todo-status-selector/todo-status-selector.component';
import { UserAvatarWithExtendedInfoComponent } from './components/user-avatar-with-extended-info/user-avatar-with-extended-info.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { UserMultiSelectorComponent } from './components/user-multi-selector/user-multi-selector.component';
import { YearSelector } from './components/year-selector/year-selector.component';
import { HideIfCountriesDirective } from './directives/hide-if-countries.directive';
import { PasteValidCorporateIdentityDirective } from './directives/paste-valid-corporate-identity.directive';
import { ShowIfBlFirmServiceDirective } from './directives/show-if-bl-firm-service.directive';
import {
  AmlRiskToTranslationKeyPipe,
  AmlRiskVariantTypePipe,
  AmlStatusToTranslationKeyPipe,
  AmlStatusVariantTypePipe,
} from './pipes/aml';
import { BlCurrencyPipe } from './pipes/bl-currency.pipe';
import { GetIconPipe } from './pipes/get-icon.pipe';
import { PickAssignmentNamePipe } from './pipes/pick-assignment-name.pipe';
import { PickTodoTypeDescriptionPipe } from './pipes/pick-todo-type-description.pipe';
import { PricePipe } from './pipes/price.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { PrimeNgModule } from './primeng.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    TranslocoModule,
    BystTableModule,
    PleaseWaitComponent,
    AssignmentSelectorComponent,
    TaskSelectorComponent,
    CalendarComponent,
    DeadlineValueComponent,
    UserMultiSelectorComponent,
    ActivityStateMultiSelectorComponent,
    ExportWizardDialogComponent,
    TaskGroupsSelectorComponent,
    PasteValidCorporateIdentityDirective,
    TeamMultiSelectorComponent,
    MultiSelectDropDownIncludingAllComponent,
    TeamBadgesComponent,
    ActivityStateSelectorComponent,
    ActivityDetailsDialog,
    AdminPrivilegeDirective,
    ProgressTimelineModule,
    FeatureToggleDirective,
    BlFrontendButtonComponent,
    BlFrontendCardComponent,
    BlFrontendLoadingButtonComponent,
    BlFrontendBadgeComponent,
    BlFrontendMiniBadgeComponent,
    BlFrontendCheckboxComponent,
    BlFrontendIconComponent,
    BlFrontendIconButtonComponent,
    BlFrontendHorizontalStepperComponent,
    BlFrontendMeatBallMenuComponent,
    BlFrontendTextInputComponent,
    BlFrontendTextAreaComponent,
    BlFrontendSegmentedbuttonComponent,
    DueComplianceActivationBoxComponent,
    ShowIfBlFirmServiceDirective,
    PartnerProgramAccessDirective,
    HideIfCountriesDirective,
    FirmCollaboratorComponent,
    TodoStatusSelectorComponent,
    UserAvatarComponent,
    UserAvatarWithExtendedInfoComponent,
    CalendarStatusIconComponent,
    // Pipes
    BlCurrencyPipe,
    PricePipe,
    AmlRiskToTranslationKeyPipe,
    AmlRiskVariantTypePipe,
    AmlStatusToTranslationKeyPipe,
    AmlStatusVariantTypePipe,
    SafeHtmlPipe,
    PickTodoTypeDescriptionPipe,
    PickAssignmentNamePipe,
    BlFrontendTooltipComponent,
    BlFrontendRadiobuttonsComponent,
    BlFrontendAlertComponent,
    BlFrontendIconComponent,
    BlFrontendEmailInputComponent,
    BlFrontendPhoneInputComponent,
  ],
  declarations: [
    AuthRoleSelectorsComponent,
    ConnectCloudCompanyDialogComponent,
    LundifySubscriptionComponent,
    PayingPartComponent,
    LundifyBundleComponent,
    ExpenseComponent,
    UsersComponent,
    ClientCloudServiceComponent,
    ApplicationLinksComponent,
    TabComponent,
    ClientBusinessDetailComponent,
    ClientFinancialYearsComponent,
    EditFinancialYearDialogComponent,
    ClientAssignmentsComponent,
    ClientActivityListDialogComponent,
    ClientContactsComponent,
    FileBrowserComponent,
    FileBrowserInternalSectionComponent,
    FileBrowserSharedSectionComponent,
    LundifyShareDialogComponent,
    ClientTodosComponent,
    TabsComponent,
    RuleSelectorComponent,
    StatusIconComponent,
    ActivityCommentIconComponent,
    TaskCommentIconComponent,
    BlaIconButtonComponent,
    GetIconPipe,
    MessagePanelComponent,
    MultiselectWithAllDropdownComponent,
    MultiselectComponent,
    PermissionSelectorComponent,
    FeatureToggle,
    MonthsSelector,
    YearSelector,
    ApplicationFilesComponent,
    NewClientDialog,
    ClientAmlComponent,
    CorporateIdentityInputComponent,
  ],
  exports: [
    PrimeNgModule,
    TranslocoModule,
    AuthRoleSelectorsComponent,
    PleaseWaitComponent,
    TabComponent,
    ActivityStateMultiSelectorComponent,
    ClientBusinessDetailComponent,
    ClientFinancialYearsComponent,
    EditFinancialYearDialogComponent,
    ClientAssignmentsComponent,
    ClientContactsComponent,
    FileBrowserComponent,
    ClientTodosComponent,
    TabsComponent,
    UserMultiSelectorComponent,
    RuleSelectorComponent,
    BlCurrencyPipe,
    PricePipe,
    TaskSelectorComponent,
    AssignmentSelectorComponent,
    StatusIconComponent,
    ActivityCommentIconComponent,
    TaskCommentIconComponent,
    BlaIconButtonComponent,
    ExportWizardDialogComponent,
    GetIconPipe,
    MessagePanelComponent,
    BystTableModule,
    MultiselectWithAllDropdownComponent,
    MultiselectComponent,
    CalendarComponent,
    DeadlineValueComponent,
    FeatureToggle,
    FeatureToggleDirective,
    ActivityStateSelectorComponent,
    MonthsSelector,
    YearSelector,
    MultiSelectDropDownIncludingAllComponent,
    ApplicationFilesComponent,
    NewClientDialog,
    ActivityDetailsDialog,
    TaskGroupsSelectorComponent,
    PasteValidCorporateIdentityDirective,
    TeamMultiSelectorComponent,
    TeamBadgesComponent,
    AdminPrivilegeDirective,
    BlFrontendButtonComponent,
    BlFrontendCardComponent,
    BlFrontendLoadingButtonComponent,
    BlFrontendCheckboxComponent,
    BlFrontendHorizontalStepperComponent,
    ShowIfBlFirmServiceDirective,
    ProgressTimelineModule,
    PartnerProgramAccessDirective,
    CorporateIdentityInputComponent,
    TodoStatusSelectorComponent,
    SafeHtmlPipe,
    PickTodoTypeDescriptionPipe,
    PickAssignmentNamePipe,
    CalendarStatusIconComponent,
  ],
  providers: [],
})
export class BystSharedModule {}
